/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PublicEventCategory = {
    id: number;
    name: string;
    description: string | null;
    color: string;
    price: string;
    taxRate: string;
    duration: number;
    location: PublicEventCategory.location;
    outageFeeEnabled: boolean;
    outageFeeHours?: number;
    outageFeePrice?: number;
    paymentEnabled: boolean;
    paymentDuringBooking: boolean;
};
export namespace PublicEventCategory {
    export enum location {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
        NOT_FIXED = 'not-fixed',
    }
}

